"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _link = _interopRequireDefault(require("next/link"));
const Root = exports.Root = (0, _mui.styled)(_link.default)((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(3),
        cursor: 'pointer'
    };
});
